<template>
  <div class="flex-c-center noRecord">
    <img src="@/assets/immunity/无数据.png" alt="" srcset="" />
    <span class="noRecord_text">{{ text }}</span>
    <van-button type="info" round v-if="isBtn" @click="goUrl">{{
      btnText
    }}</van-button>
  </div>
</template>

<script>
export default {
  name: "emptyData",
  props: {
    // 描述文字
    text: {
      type: String,
      required: true,
      default: "",
    },
    // 是否展示按钮
    isBtn: {
      type: Boolean,
      default: false,
    },
    // 按钮文字
    btnText: {
      type: String,
      default: "",
    },
    // 按钮链接
    btnUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  methods: {
    goUrl() {
      this.$router.push(this.btnUrl);
    },
  },
};
</script>
